module.exports = __webpack_public_path__ + "img/light.59fb14fb.svg";